import React from "react";
import { formatujPercentoText } from "../utils/formatovanie";
import { ziskajLogoBanky, ziskajStylLogaBanky } from "../utils/bankoveLoga";

export default function PrehladZliavPrirazokKarta({ bankaKod, prehlad }) {
  const zlavy = Array.isArray(prehlad?.zlavy) ? prehlad.zlavy : [];
  const prirazky = Array.isArray(prehlad?.prirazky) ? prehlad.prirazky : [];

  const maText = (v) => typeof v === "string" && v.trim() !== "";

  const jeValidnaPolozka = (p, jeZlava) => {
    if (!p) return false;

    const maHodnotu = Number.isFinite(Number(p?.hodnota));
    const maPodlaFixacie =
      Array.isArray(p?.podlaFixacie) &&
      p.podlaFixacie.some((x) =>
        Number.isFinite(Number(x?.fixaciaRoky)) &&
        Number.isFinite(Number(x?.hodnota))
      );

    if (!maHodnotu && !maPodlaFixacie) return false;

    const maNazov = maText(p?.nazov);
    const maPoznamku = maText(p?.poznamka);
    const maPodmienkyText = maText(p?.podmienkyText);
    const maTypy = Array.isArray(p?.typyHypoteky) && p.typyHypoteky.filter(Boolean).length > 0;

    const maNadSuma = jeZlava && Number.isFinite(Number(p?.nadSuma));
    const maNadLtv = !jeZlava && Number.isFinite(Number(p?.nadLTV));

    return maNazov || maPoznamku || maPodmienkyText || maTypy || maNadSuma || maNadLtv;
  };

  const zlavyCiste = zlavy.filter((p) => jeValidnaPolozka(p, true));
  const prirazkyCiste = prirazky.filter((p) => jeValidnaPolozka(p, false));
  const logoBanky = ziskajLogoBanky(bankaKod);
  const stylLogaBanky = ziskajStylLogaBanky(logoBanky);

  const vykresliPolozky = (arr, jeZlava) => {
    if (!arr.length) return "nie sú";

    return arr.map((p, idx) => {
      const nazov = p?.nazov ? String(p.nazov) : "";
      const hodnota = p?.hodnota;
      const podlaFixacie = Array.isArray(p?.podlaFixacie) ? p.podlaFixacie : [];
      const hodnotaText = p?.hodnotaText ? String(p.hodnotaText) : "";

      const podm = jeZlava
        ? (Number.isFinite(p?.nadSuma) ? `nad sumu ${p.nadSuma} €` : (p?.podmienkyText ? String(p.podmienkyText) : ""))
        : (Number.isFinite(p?.nadLTV) ? `nad LTV ${p.nadLTV}%` : "");

      const typy = Array.isArray(p?.typyHypoteky) ? p.typyHypoteky : [];
      const poz = p?.poznamka ? String(p.poznamka) : "";

      return (
        <div key={`${bankaKod}-${jeZlava ? "zl" : "pr"}-${idx}`}>
          <div>
            {nazov ? `${nazov}: ` : ""}
            {podlaFixacie.length
            ? podlaFixacie
                .filter((x) =>
                  Number.isFinite(Number(x?.fixaciaRoky)) &&
                  Number.isFinite(Number(x?.hodnota))
                )
                .map((x) => `${formatujPercentoText(Number(x.hodnota))} pre ${Number(x.fixaciaRoky)}R FIX`)
                .join(", ")
            : (hodnotaText || (Number.isFinite(Number(hodnota)) ? formatujPercentoText(hodnota) : "—"))}
          </div>

          {typy.length ? <div className="note">{typy.join(", ")}</div> : null}
          {podm ? <div className="note">{podm}</div> : null}
          {poz ? <div className="note">{poz}</div> : null}
          {idx !== arr.length - 1 ? <div className="prehlad-item-gap"></div> : null}
        </div>
      );
    });
  };

  return (
    <div className="porovnavac-banka-card prehlad-zp-card">
      <div className="porovnavac-banka-head">
        <div className="porovnavac-banka-nazov prehlad-zp-banka banka-head-with-logo">
          {logoBanky ? (
            <span
              className={`banka-logo-obal banka-logo-obal--${logoBanky.variant || "wide"}`}
              style={stylLogaBanky}
            >
              {logoBanky.srcDark ? (
                <>
                  <img
                    src={logoBanky.src}
                    alt={`${bankaKod} logo`}
                    className={`banka-logo banka-logo--light banka-logo--fit-${logoBanky.fit || "contain"}`}
                  />
                  <img
                    src={logoBanky.srcDark}
                    alt={`${bankaKod} logo`}
                    className={`banka-logo banka-logo--dark banka-logo--fit-${logoBanky.fit || "contain"}`}
                  />
                </>
              ) : (
                <img
                  src={logoBanky.src}
                  alt={`${bankaKod} logo`}
                  className={`banka-logo banka-logo--fit-${logoBanky.fit || "contain"}`}
                />
              )}
            </span>
          ) : null}

          {/* <span className="banka-head-with-logo__kod">{bankaKod}</span> */}
        </div>
      </div>

      <div>
        <div className="porovnavac-banka-m">
          <div className="k prehlad-zp-nadpis">Zľavy</div>
          <div className="v prehlad-zp-obsah">{vykresliPolozky(zlavyCiste, true)}</div>
        </div>

        <div className="parametre-divider"></div>

        <div className="porovnavac-banka-m">
          <div className="k prehlad-zp-nadpis">Prirážky</div>
          <div className="v prehlad-zp-obsah">{vykresliPolozky(prirazkyCiste, false)}</div>
        </div>
      </div>
    </div>
  );
}